<template>
  <div class="footer">
    <div class="refer-box">
      <div class="ref-box">
        <img
          class="footer-code"
          src="../static/images/concatCode.png"
          alt=""
        />
        <div class="fs12">微信扫码添加咨询</div>
      </div>
    </div>
    <div class="content">
      <div class="pages-list">
        <div @click="changePage('')" :class="{ active: props.curPage == '' }">
          首页
        </div>
        <div
          @click="changePage('product')"
          :class="{ active: props.curPage == 'product' }"
        >
          产品介绍
        </div>
        <div
          @click="changePage('download')"
          :class="{ active: props.curPage == 'download' }"
        >
          产品下载
        </div>
        <div
          @click="changePage('about')"
          :class="{ active: props.curPage == 'about' }"
        >
          关于我们
        </div>
        <div class="refer">
          <img
            class="footer-code"
            src="../static/images/concatCode.png"
            alt=""
          />
          <div class="fs12">微信扫码添加咨询</div>
        </div>
      </div>
      <div class="copyWith foot-text">
        <!-- <div class="df-start">
          <img
            class="icon"
            src="../static/images/footer/footer-icon1.png"
            alt=""
          />
          <div class="mr10">
            <a
              href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502044257"
              >京公网安备31011502018605号</a
            >
          </div>
        </div> -->
        <div class="mr10">
          <a href="https://beian.miit.gov.cn/#/Integrated/index"
            >津ICP备2024021923号-3</a
          >
        </div>
        <div class="df-start">
          <img
            class="icon1"
            src="../static/images/footer/footer-icon2.png"
            alt=""
          />
          <div>Copyright © 2022-2025 铂视保. All Rights Reserved.</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { defineEmits, defineProps } from "vue";
const props = defineProps(["curPage"]);
const emit = defineEmits(["changePage"]);

const changePage = (page) => {
  emit("changePage", page);
};
</script>
<style lang="scss">
@import "@/style/main.scss";
@import "@/style/common.scss";
.footer {
  margin-top: 1px;
  width: 100%;
  // height: 270px;
  padding: 0 200px;
  box-sizing: border-box;
  background-color: #303030;
  color: #fff;

  .pages-list {
    display: flex;
    justify-content: space-around;
    align-items: baseline;
    font-size: 14px;
    margin-bottom: 20px;
    padding-top: 32px;
    cursor: pointer;
    > div {
      color: #dadada;
    }
    > .active {
      font-weight: bold;
      color: #fff;
    }
    .footer-code {
      width: 98px;
      height: 98px;
      margin-bottom: 16px;
    }
  }
  .fs12 {
    font-size: 12px !important;
  }
  .copyWith {
    font-size: 14px;
    border-top: 1px solid #ffffff;
    height: 84px;
    line-height: 84px;
    > img {
      width: 16px;
      height: 16px;
      margin-right: 8px;
    }
    .mr10 {
      margin-right: 30px;
    }
    .icon {
      width: 16px;
      height: 16px;
      margin-right: 8px;
    }
    .icon1 {
      width: 11px;
      height: 11px;
      margin-right: 4px;
    }
    a {
      color: #fff;
    }
  }
}
</style>